// Fields stored under `attribute.properties`. Anything not listed here is
// written on the attribute itself (`label`, `name`, `value`, …).
const PROPERTY_FIELDS = new Set([
    'required',
    'minSelections',
    'readOnly',
    'staffOnly',
    'aiSummary',
    'customPrompt',
    'aiAssist',
    'goalMode',
    'targetMode',
    'conditions',
    'width',
    'options',
    'headers',
    'table',
    'sessionDataTable',
    'inline',
    'backgroundColor',
    'showMastery',
    'showGoalEvent',
    'showTargetEvent',
    'showBaseline',
    'showClientEvent',
    'showTrendLine',
    'showAverageLine',
    'valueMode',
    'sessionGroupBy',
    'chartSettings',
    'graphType',
    'signerMode',
    'signerRole',
    'signerUser',
    'signatureFill',
]);

/** Immutably write one field onto a single attribute. */
export const writeField = (attribute = {}, field, value) => {
    if (PROPERTY_FIELDS.has(field)) {
        return {
            ...attribute,
            properties: { ...(attribute.properties || {}), [field]: value },
        };
    }

    // Switching the date mode invalidates both the captured value and the
    // graph event flags, which were chosen for the previous mode.
    if (field === 'defaultDateType') {
        return {
            ...attribute,
            defaultDateType: value,
            value: null,
            properties: {
                ...(attribute.properties || {}),
                showMastery: false,
                showGoalEvent: false,
                showClientEvent: false,
            },
        };
    }

    return { ...attribute, [field]: value };
};
